import { useAppSelector } from 'app/redux/store';
import { DateTime } from 'luxon';

export const useUtcDateTimeEnd = () => {
  const { mapTimeMillis } = useAppSelector(state => state.map);
  const { ianaTimezone } = useAppSelector(state => state.profile.facility);
  const dateTimeEnd = DateTime.fromMillis(mapTimeMillis, { zone: ianaTimezone }).toUTC().toISO();
  return dateTimeEnd;
};
